export default __webpack_public_path__ + "static/media/stripe_all.819bbc99.png";